// Workspace operational status (status.rs): one row per screen with location
// service health and the latest estimate. The Overview page polls this — a
// short interval keeps the wall of numbers honest without per-screen
// fan-out.

import { useQuery } from "@tanstack/react-query";
import { http } from "./http";
import { statusKeys } from "./keys";
import type { StatusRow } from "./types";

export const STATUS_REFRESH_MS = 15_000;

export function useWorkspaceStatus(workspaceId: string) {
    return useQuery({
        queryKey: statusKeys.list(workspaceId),
        queryFn: () => http.get<StatusRow[]>(`/v1/workspaces/${workspaceId}/status`),
        refetchInterval: STATUS_REFRESH_MS,
        enabled: Boolean(workspaceId),
    });
}
